import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { useOrder, useUpdateOrder } from "../hooks";
import { OrderForm } from "../components";

type IUpdateOrder = {
  id: string;
};

export const UpdateOrder: React.FC = () => {
  const { id } = useParams<IUpdateOrder>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useOrder(+id!);
  const { form, submit, loading } = useUpdateOrder({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("La commande a été modifiée avec succès");
    },
  });

  useEffect(() => {
    if (data?.order?.ok && data?.order?.result) {
      const { result } = data.order;
      form.setValue("number", result.number);
      form.setValue("customerId", result.customer?.id);
      form.setValue("salesRepId", result.salesRep?.id);
      form.setValue("status", result.status);
      form.setValue("paymentStatus", result.paymentStatus);
      form.setValue("deliveryStatus", result.deliveryStatus);
      form.setValue("deliveryFeeOrigin", result.deliveryFeeOrigin);
      form.setValue(
        "plannedDeliveryAt",
        result.plannedDeliveryAt ? result.plannedDeliveryAt.slice(0, 10) : undefined
      );
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  return (
    <>
      <Header
        title="Commande"
        subtitle={data?.order?.result?.number ?? `#${id}`}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/order/${id}`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier une commande" />
          <OrderForm loading={loading} form={form} submit={submit} isEditing />
        </div>
      </div>
    </>
  );
};
